import { Component, OnInit } from '@angular/core';
import { MediaService } from '../media.service';
import { NgClass } from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.css']
})
export class MediaComponent implements OnInit {
  
  public loading = false;

  public media_list: Array<any>;

  public media_type: string;

  public max_page_array: Array<any>;

  public media_selected: Array<any> = [];

  constructor(private media: MediaService) {
      this.media_type = 'all';
      this.media.reset_media_type(this.media_type);

  }

  /* get any kind of media list */
  get_media_list(){

    this.loading = true;
    this.media_list_subscriber();

  }

  /* Media list subscriber function */
  media_list_subscriber(){

    this.media.get_media_list().subscribe((res)=>{

      let data_received = res.json();
      this.media_list = data_received['data'];
      this.media.max_pages = data_received['max_pages'];
      this.max_page_array = Array(this.media.max_pages).fill(undefined);
      this.loading = false;

    },
    (error)=>{
      let data_received = error.json();
      alert(data_received.message);
      this.loading = false;
    }
    );

  }

  /* get media list bsed on media type selected */
  change_media_type($event){

    this.loading = true;
    this.media.reset_media_type(this.media_type);
    this.media_list_subscriber();

  }

  /* Update Single Media */
  update_media(index, $event){
    
    this.loading = true;
    this.media.update_media([this.media_list[index]]).subscribe(res => {
      let result = res.json();
      this.loading = false;
    });

  }

  /* Update all media in list */
  update_all($event){
    
    this.loading = true;
    this.media.update_media(this.media_list).subscribe(res => {
      let result = res.json();
      this.loading = false;
    });

  }

  /* Next page */
  next_page($event){
    if(this.media.next_page()){
      this.get_media_list();
    }
  }

  /* Previous page */
  previous_page($event){
    if(this.media.previous_page()){
      this.get_media_list();
    }
  }

  /* Go to perticular page */
  go_to_page(i,$event){
    if(i <= this.media.max_pages && i != this.media.page_number){
      this.media.page_number = i;
      this.get_media_list();
    }
  }

  /* This function will add alt, caption , desc from main feald to all 
  images that have missing alt ,desc, caption */
  add_to_all(caption, alt, desc){
    (this.media_list).forEach(function(media){
        
        if(caption != "" && media.caption == ""){
          media.caption = caption;
        }

        if(alt != "" && media.alt == ""){
          media.alt = alt;
        }

        if(desc != "" && media.description == ""){
          media.description = desc;
        }
    });
    
  }

  /* */
  add_to_selected(caption, alt, desc){
    console.log(this.media_selected);
    (this.media_list).forEach((media) => {
      
      if(this.media_selected.indexOf(media.id) != -1){
        
          if(caption != "" && media.caption == ""){
            media.caption = caption;
          }

          if(alt != "" && media.alt == ""){
            media.alt = alt;
          }

          if(desc != "" && media.description == ""){
            media.description = desc;
          }

      }

    });
  }

  /* This function is called to add element in selected_media list this is used to 
  fill detial only for selected media */ 
  selected_media_list(id, event){
    if(event.target.checked){
      this.media_selected.push(id);
    }else{
      this.media_selected.splice(this.media_selected.indexOf(id),1);
    }
    //console.log(this.media_selected);
  }

  ngOnInit() {  
    this.get_media_list();
  }

}



// WEBPACK FOOTER //
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/media/media.component.ts